import React, { useState, useEffect } from 'react';
import { Menu, X, Leaf } from 'lucide-react';
// import { useAuth } from '../contexts/AuthContext';
import { useLoginModal } from '../contexts/LoginModalContext';
import { LoginModal } from './auth/LoginModal';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  // const { user, signOut } = useAuth();
  const { isLoginModalOpen, hideLoginModal } = useLoginModal();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigation = [
    { name: 'Hem', href: '/' },
    { name: 'Tjänster', href: '/#services' },
    { name: 'Om Hampa', href: '/#about-hemp' },
    { name: 'Kalkylator', href: '/kalkyl' },
    // { name: 'Nyheter', href: '/nyheter' },
    { name: 'Bildgalleri', href: '/#gallery' },
    { name: 'Frågor & Svar', href: '/#faq' },
    { name: 'Om Oss', href: '/#about-us' },
    { name: 'Kontakt', href: '/#contact' },
  ];

  const handleNavClick = (href: string) => {
    if (href.startsWith('/#')) {
      // Handle anchor links
      if (window.location.pathname !== '/') {
        // Navigate to landing page with hash - will trigger scroll on load
        window.location.href = href;
      } else {
        // Already on landing page, just scroll
        const element = document.querySelector(href.substring(1));
        if (element) {
          const headerHeight = 80;
          const elementPosition = (element as HTMLElement).offsetTop - headerHeight;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }
    } else {
      // Handle regular routes
      window.location.href = href;
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-lg' 
        : 'bg-transparent'
    }`}>
      <nav className="container-max section-padding">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('/');
            }}
            className="flex items-center space-x-3 hover:opacity-80 transition-opacity cursor-pointer"
          >
            <img
              src="/logo.png"
              alt="Hampaoasen Logo"
              className="w-12 h-12 object-contain"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                target.nextElementSibling?.classList.remove('hidden');
              }}
            />
            <div className="w-10 h-10 bg-hemp-600 rounded-full flex items-center justify-center hidden">
              <Leaf className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-hemp-800">Hampaoasen</h1>
              <p className="text-xs text-hemp-600 -mt-1">Hampa & Biologisk Mångfald</p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-hemp-700 hover:text-hemp-900 font-medium transition-colors duration-200 relative group"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
              >
                {item.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-hemp-600 transition-all duration-200 group-hover:w-full"></span>
              </a>
            ))}

            {/* Auth Button */}
            {/* {user ? (
              <div className="flex items-center space-x-3">
                <span className="text-hemp-600 text-sm">
                  {user.profile?.full_name || user.email}
                </span>
                <button
                  onClick={() => signOut()}
                  className="flex items-center space-x-1 text-hemp-600 hover:text-hemp-800 transition-colors duration-200"
                  title="Logga ut"
                >
                  <LogOut className="w-5 h-5" />
                </button>
              </div>
            ) : (
              <button
                onClick={showLoginModal}
                className="text-hemp-600 hover:text-hemp-800 font-medium transition-colors duration-200"
              >
                Logga in
              </button>
            )} */}
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2 rounded-lg text-hemp-700 hover:bg-hemp-100 transition-colors duration-200"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-hemp-200 bg-white/95 backdrop-blur-md rounded-b-lg shadow-lg">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-hemp-700 hover:text-hemp-900 font-medium py-2 px-4 rounded-lg hover:bg-hemp-50 transition-all duration-200"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                >
                  {item.name}
                </a>
              ))}

              {/* Mobile Auth Button */}
              {/* {user ? (
                <div className="flex items-center justify-between py-2 px-4 border-t border-hemp-200 mt-2 pt-4">
                  <span className="text-hemp-600 text-sm">
                    {user.profile?.full_name || user.email}
                  </span>
                  <button
                    onClick={() => {
                      signOut();
                      setIsMenuOpen(false);
                    }}
                    className="flex items-center space-x-1 text-hemp-600 hover:text-hemp-800 transition-colors duration-200"
                  >
                    <LogOut className="w-5 h-5" />
                    <span>Logga ut</span>
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => {
                    showLoginModal();
                    setIsMenuOpen(false);
                  }}
                  className="text-hemp-600 hover:text-hemp-800 font-medium py-2 px-4 transition-colors duration-200"
                >
                  Logga in
                </button>
              )} */}
            </div>
          </div>
        )}
      </nav>

      {/* Login Modal */}
      <LoginModal isOpen={isLoginModalOpen} onClose={hideLoginModal} />
    </header>
  );
};

export default Header;